module.exports = __webpack_public_path__ + "img/c53.fc5baa8a.png";